"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVerifySlipLinksMutation = exports.useRemoveSlipLogoMutation = exports.useUploadSlipLogoMutation = exports.useSaveBuildingSlipConfigMutation = exports.useFetchBuildingSlipConfigQuery = exports.buildingSlipConfigApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.buildingSlipConfigApi = (0, react_1.createApi)({
    reducerPath: "buildingSlipConfigApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["buildingSlipConfig"],
    endpoints: function (builder) { return ({
        fetchBuildingSlipConfig: builder.query({
            query: function (_a) {
                var clientId = _a.clientId, buildingId = _a.buildingId;
                return ({
                    url: "/v1/building-slip-config/fetch",
                    method: "GET",
                    params: { clientId: clientId, buildingId: buildingId },
                });
            },
            providesTags: ["buildingSlipConfig"],
        }),
        saveBuildingSlipConfig: builder.mutation({
            query: function (body) { return ({
                url: "/v1/building-slip-config/save",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: ["buildingSlipConfig"],
        }),
        // Multipart logo upload — send a FormData with clientId/buildingId/slot/savedBy + `logo` file.
        uploadSlipLogo: builder.mutation({
            query: function (formData) { return ({
                url: "/v1/building-slip-config/logo",
                method: "POST",
                body: formData,
            }); },
            invalidatesTags: ["buildingSlipConfig"],
        }),
        removeSlipLogo: builder.mutation({
            query: function (body) { return ({
                url: "/v1/building-slip-config/logo/remove",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: ["buildingSlipConfig"],
        }),
        verifySlipLinks: builder.mutation({
            query: function (body) { return ({
                url: "/v1/building-slip-config/verify-links",
                method: "POST",
                body: body,
            }); },
        }),
    }); },
});
exports.useFetchBuildingSlipConfigQuery = exports.buildingSlipConfigApi.useFetchBuildingSlipConfigQuery, exports.useSaveBuildingSlipConfigMutation = exports.buildingSlipConfigApi.useSaveBuildingSlipConfigMutation, exports.useUploadSlipLogoMutation = exports.buildingSlipConfigApi.useUploadSlipLogoMutation, exports.useRemoveSlipLogoMutation = exports.buildingSlipConfigApi.useRemoveSlipLogoMutation, exports.useVerifySlipLinksMutation = exports.buildingSlipConfigApi.useVerifySlipLinksMutation;
